// extracted by mini-css-extract-plugin
export var divider = "_uh-0";